import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import swal, { SweetAlertResult } from 'sweetalert2';

export enum S1PopUpType {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
  Question = "question"
}

@Injectable({
  providedIn: 'root'
})
export class S1UIService {

  constructor(private translate: TranslateService, private toasterService: ToastrService) { 
    
  }

  // Spinner
  showSpinner() {

    swal.fire({
      title: this.translate.instant('s1.swal.loading'),
      didOpen: () => {
          swal.showLoading();
      }
    });

  }

  closeSpinner() {
    swal.close();
  }

  // Popup
  showPopup(type: S1PopUpType, title?: string, text?: string) {

    swal.fire(this.translate.instant(title),this.translate.instant(text)  , type);

  }

  showPopupNoPermission() {
    this.showPopup(S1PopUpType.Warning, 's1.swal.attention',  's1.swal.noPermission')
  }

  async showHTTPErrorPopup(error: any) {

    
    let errorTitle = 's1.error'
    let errorMessage = 'genericError'

    console.log("Error: ", error);

    const text = error.error?.text
    

    if (typeof(text) === 'function') {

      const errorLbl = await error.error?.text();
      errorMessage = this.translate.instant(errorLbl);

    } else if (error.statusText) {
      errorMessage = this.translate.instant(error.statusText);
    }

    if (error.status) {

      errorTitle = "" + error.status

      switch(error.status) {
        case 401: // Unauthorized
        case 403: // Forbidden
          errorMessage = this.translate.instant('APIErrors.' + error.status)
          break;
      }

    }

    this.showPopup(S1PopUpType.Error, errorTitle, errorMessage)

  }

  showDialogPopup(title: string): Promise<SweetAlertResult> {

    return swal.fire({
      title: this.translate.instant('s1.swal.attention'),
      text: this.translate.instant(title),
      icon: S1PopUpType.Question,
      showCloseButton: true,
      showCancelButton: true
    })

  }

  /*showSelectionPopup(title: string, elementList: any): Promise<any> {

    return swal({
      title: this.translate.instant(title),
      type: "question",
      input: 'radio',
      inputOptions: elementList
    });

  }
*/
  showInputPopup(title: string, text: string, fieldText: string, initialValue: string = null): Promise<any> {

    return swal.fire({
      title: this.translate.instant(title),
      text: text,
      input: 'text',
      inputValue: initialValue,
      inputPlaceholder: null// this.translate.instant(fieldText),
    });

  }

  // Popup con area di testo obbligatoria (es. motivazione di un rifiuto)
  showTextAreaPopup(title: string, requiredMessage: string): Promise<SweetAlertResult<string>> {

    return swal.fire({
      title: this.translate.instant(title),
      input: 'textarea',
      showCancelButton: true,
      showCloseButton: true,
      inputValidator: (value: string) => !value?.trim() ? this.translate.instant(requiredMessage) : null
    });

  }

  // TOAST
  showSuccessToast(text: string) {
    this.toasterService.success(this.translate.instant(text), this.translate.instant("s1.toast.success"),{timeOut:2000});
  }

}
